export default "__VITE_ASSET__e738c643__"